module.exports = __webpack_public_path__ + "static/img/BLAKE-THREDGOLD.f56b9a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLAKE-THREDGOLD.jpg
// module id = 4OrU
// module chunks = 0